import React from "react";

const WhyUs = () => {
  return (
    <section className="max-w-7xl mx-auto px-6 ">
      <div className="text-center mb-1">
        <h2 className="text-5xl font-bold text-black-900">Why Choose Us?</h2>
      </div>

      <div className="flex flex-col md:flex-row items-center gap-10">
        {/* Left Text Content */}
        <div className="md:w-1/2 text-black-700 text-xl space-y-6">
          <p>
            We go beyond just offering services we deliver measurable results
            and meaningful partnerships. Our team blends innovation, expertise,
            and customer-first strategies to help your business thrive in a
            competitive market. With a strong track record of success,
            customized solutions tailored to your goals, and a relentless
            commitment to quality, we’re not just a service provider we’re your
            growth partner. 
          </p>
        </div>

        {/* Right Image */}
        <div className="md:w-1/2 flex justify-center">
          <img
            src="/question.png"
            alt="Why Choose Us"
            className="w-48 md:w-96 object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
